// 만보계 · 걸음 랭킹 공통 표기 유틸

export type StepPeriodKey = "today" | "week" | "month";

export const STEP_PERIODS: { key: StepPeriodKey; label: string }[] = [
  { key: "today", label: "오늘" },
  { key: "week", label: "이번주" },
  { key: "month", label: "이번달" },
];

// 5321 → "5,321"
export function formatNumber(v?: number | string): string {
  const n = Number(v ?? 0);
  if (!Number.isFinite(n)) return "0";
  return Math.round(n).toLocaleString("ko-KR");
}

// 21.71 → "21.7"
export function formatKm(v?: number | string): string {
  const n = Number(v ?? 0);
  if (!Number.isFinite(n)) return "0.0";
  return n.toFixed(1);
}

// 0(기록 없음) 처리
export function hasRank(rank?: number): boolean {
  return Number(rank ?? 0) > 0;
}

// "4위" / 기록 없으면 "기록 없음"
export function rankLabel(rank?: number): string {
  return hasRank(rank) ? `${Number(rank)}위` : "기록 없음";
}

// 1~3위 메달
export function medalFor(rank?: number): string | null {
  const n = Number(rank ?? 0);
  if (n === 1) return "🥇";
  if (n === 2) return "🥈";
  if (n === 3) return "🥉";
  return null;
}

// "2026-10-05" → "10월 5일"
export function formatMonthDay(value?: string): string {
  if (!value) return "";
  const d = new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return value;
  return `${d.getMonth() + 1}월 ${d.getDate()}일`;
}

// "10월 5일 ~ 10월 11일"
export function formatRange(from?: string, to?: string): string {
  const a = formatMonthDay(from);
  const b = formatMonthDay(to);
  if (a && b) return `${a} ~ ${b}`;
  return a || b;
}

// 걸음 수 기준 진행률(%) — 목표 대비
export function percentOf(steps?: number, goal?: number): number {
  const s = Number(steps ?? 0);
  const g = Number(goal ?? 0);
  if (g <= 0) return 0;
  return Math.max(0, Math.min(100, Math.round((s / g) * 100)));
}